import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {
	parseJSON, 
	isOk, 
	authReq, 
} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/


// None yet



/******************************
*******  Asynchronous  ********
******************************/




export function financeFetchPlans(signal = null) {

	return dispatch => {

		let url = api.API_URL + endpoint.FINANCE_FETCH_PLANS;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		  signal
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data.plans);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function financeCreatePlan(createData, signal = null) {

	return dispatch => {
		let url = api.API_URL + endpoint.FINANCE_CREATE_PLAN;
		return fetch(url, {
		  method: 'put',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(createData),
		  signal
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function financeEditPlan(editData, signal = null) {

	return dispatch => {
		let url = api.API_URL + endpoint.FINANCE_EDIT_PLAN;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(editData),
		  signal
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function financeDeletePlan(deleteData, signal = null) {

	return dispatch => {
		let url = api.API_URL + endpoint.FINANCE_DELETE_PLAN;
		return fetch(url, {
		  method: 'delete',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(deleteData),
		  signal
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

























